import { ITextJoinBehavior, IJoinedObject, IJoinedString } from "../../../../../../../documaker/domain/format/objects";
import { IJoinTextObjectBean } from "../../../beans/objects";
import { IJoinTextItemBean } from "../../../beans/objects/items";
import { ItemsTranslator } from "./ItemsTranslator";
import { IntegerTranslator } from "../../values";

export class TextJoinBehaviorTranslator {
  from(bean: IJoinTextObjectBean): ITextJoinBehavior {
    return {
      shouldJoinWithNewLine: bean["@join-word"] && (bean["@join-word"] === "1"),
      items: this.items.from(
        bean.jointextitem,
        s => {
          const isObject = (s["@item-type"] === "1");
          return {
            isObject,
            reference: isObject
              ? this.itemAsObject.from(s)
              : this.itemAsString.from(s),
          };
        },
      ),
    };
  }

  to(object: ITextJoinBehavior) {
    return {
      joinWord: object.shouldJoinWithNewLine ? "1" : undefined,
      joinTextItem: this.items.to(
        object.items,
        s => s.isObject
          ? this.itemAsObject.to(s.reference as IJoinedObject)
          : this.itemAsString.to(s.reference as IJoinedString),
      ),
    };
  }

  private readonly itemAsObject = {
    from: (bean: IJoinTextItemBean): IJoinedObject => ({
      type: bean["@type"],
      id: this.integer.from(bean["@obj-id"]),
      key: bean["@key"],
    }),
    to: (object: IJoinedObject) => ({
      "@name": "",
      "@item-type": "1",
      "@type": object.type,
      "@obj-id": object.type !== "combo" ? this.integer.to(object.id) : undefined,  // v1のXMLにはリストのobj-id属性は出力していない(仕様？)ため同様に処理している
      "@key": object.key,
    }),
  };

  private readonly itemAsString = {
    from: (bean: IJoinTextItemBean): IJoinedString => ({
      value: bean["@value"],
    }),
    to: (object: IJoinedString) => ({
      "@name": "",
      "@item-type": "2",
      "@value": object.value,
    }),
  };

  private readonly items = new ItemsTranslator();
  private readonly integer = new IntegerTranslator();
}
